module.exports = __webpack_public_path__ + "media/images/athletes/1388-aefba9acb875ca368e2d5968d93ba12e.png";